import React from "react";
import {
  getCurrentLangFromRedux,
  getDir,
} from "../../../algorithms/styleChanges";
import {
  contentEnd,
  contentStart,
  styleStart,
} from "../../../algorithms/styleDirection";
export default function CommentHeader({ procedureCount, lang, onAddComment }) {
  const isRTL = getDir(getCurrentLangFromRedux()) === "rtl";
  return (
    <div
      className={`d-flex mx-4 py-2 align-items-center ${styleStart(
        "p",
        5,
        "md",
      )} ${styleStart("p", 4, "xl")}`}
    >
      <span className="text-muted" style={{ fontSize: 15 }}>
        {procedureCount > 0 ? lang.lastcommentWasAdded : lang.thereIsNocomments}
      </span>

      <hr
        className="col-md-3 col-lg-5 col-xl-7 mx-2 d-none d-sm-block"
        style={{ backgroundColor: "#707070" }}
      />

      <div
        className={`d-flex align-items-center col ${
          isRTL
            ? contentStart("justify-content")
            : contentEnd("justify-content")
        } ${
          isRTL
            ? contentEnd("justify-content", "md")
            : contentStart("justify-content", "md")
        }`}
        style={{ cursor: "pointer" }}
        onClick={onAddComment}
      >
        <div
          className="d-flex justify-content-center align-items-center plusIcon"
          style={{
            backgroundColor: "#0c574b",
            width: 26,
            height: 26,
            borderRadius: "50%",
          }}
        >
          <div
            style={{
              width: 16,
              height: 16,
              background:
                "url('/assets/images/icons/Path 184.png') center/contain no-repeat",
              filter: "brightness(20)",
            }}
          />
        </div>

        <span className="mx-2">{lang.addcomments}</span>
      </div>
    </div>
  );
}
